import { render, staticRenderFns } from "./RevenueCenters.vue?vue&type=template&id=0b2d4554&scoped=true"
import script from "./RevenueCenters.vue?vue&type=script&lang=js"
export * from "./RevenueCenters.vue?vue&type=script&lang=js"
import style0 from "./RevenueCenters.vue?vue&type=style&index=0&id=0b2d4554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2d4554",
  null
  
)

export default component.exports